import PropTypes from 'prop-types';
import React from 'react';
import Slider from 'react-slick';
import {
  compose,
  withHandlers,
  withState,
  withStateHandlers,
} from 'recompose';

const CarouselItem = ({
  handleClick,
  highlightedClass = 'slide-image--highlighted',
  isHighlighted = false,
  src,
}) => (
  <div className="slick-slide">
    <div className={`slide-image ${isHighlighted ? highlightedClass : ''}`}>
      <img className="img-fluid" src={src} alt="" onClick={handleClick}/>
    </div>
  </div>
);

export const GalleryCarousel = ({
  handleClick = () => null,
  highlightedClass,
  images = [],
  selectedId,
  settings = {},
}) => (
  <div className="slick-image-slider">
    <Slider {...settings}>
      {
        images.map(({ id, src }, index) => <CarouselItem
          handleClick={() => handleClick(id)}
          highlightedClass={highlightedClass}
          isHighlighted={selectedId == id} // eslint-disable-line eqeqeq
          key={`carousel-item-${index}`}
          src={src}/>)
      }
    </Slider>
  </div>
);

GalleryCarousel.propTypes = {
  images: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    src: PropTypes.string.isRequired,
  })),
};

export const UndecoratedSyncedCarousels = ({
  images = [],
  carouselRef = null,
  previewRef = null,
  setRef = () => null,
  carouselSettings = {
    asNavFor: previewRef,
    className: 'synced-carousels__carousel',
    focusOnSelect: true,
    ref: slider => setRef('carouselRef', slider),
    slidesToScroll: 1,
    slidesToShow: images.length > 4 ? 4 : images.length,
  },
  previewSettings = {
    asNavFor: carouselRef,
    className: 'synced-carousels__preview',
    ref: slider => setRef('previewRef', slider),
    slidesToScroll: 1,
    slidesToShow: 1,
  },
}) => (
  <div className="synced-carousels">
    <GalleryCarousel images={images} settings={previewSettings}/>
    <GalleryCarousel images={images} settings={carouselSettings}/>
  </div>
);

export const SyncedCarousels = compose(withStateHandlers({
  previewRef: null,
  carouselRef: null,
}, {
  setRef: () => (ref, slider) => ({ [ref]: slider }),
}))(UndecoratedSyncedCarousels);

export const UndecoratedGalleryCarouselWithPreview = ({
  carouselSettings = {
    className: 'gallery-carousel',
    infinite: false,
    slidesToScroll: 1,
    slidesToShow: 3,
  },
  handleClick = () => null,
  images = [],
  video = video,
  selectedId = 0,
}) => (
  <div>
    {images.length > 0 && <div className="gallery-main">
      <ViewGallery video={video} images={images} selectedId={selectedId}/>
    </div>
    }
    <GalleryCarousel
      handleClick={handleClick}
      images={images}
      selectedId={selectedId}
      settings={carouselSettings}/>
    <div className="modal fade" id="gallery-expanded" tabIndex="-1" role="dialog">
      <div className="modal-dialog modal-md">
        <div className="modal-content">
          <div className="modal-header justify-content-end pb-0">
            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <SyncedCarousels images={images}/>
          </div>
        </div>
      </div>
    </div>
  </div>
);

const ViewGallery = ({
  video, 
  images, 
  selectedId
}) => {

  return (video.hasVideo && selectedId === images.length - 1 ) ? <GalleryVideo video={video}/> : <GalleryImage images={images} selectedId={selectedId}/>
}

const GalleryImage = ({
  images, 
  selectedId
}) => {
  return (
    <div>
      <img
        src={images.find(({ id }) => id === selectedId).src}
        alt=""
        data-toggle="modal"
        data-target="#gallery-expanded"/>
      <i className="fa fa-expand gallery-main__icon-expand"/>
    </div>
  );
}

const GalleryVideo = ({ video: {
  videoAutoplay,
  videoHeight,
  videoId,
  videoUrl
}}) => {
  /* Due to Autoplay policy, videos that are autoplayed would have to be muted as well.
    video param autoplay = mute
  */
  const src = `${videoUrl}${videoId}${'?autoplay='}${videoAutoplay}${'&mute='}${videoAutoplay}`;

  return (
    <iframe 
      width='100%' 
      height={videoHeight} 
      src={src}
      allowFullScreen='true'/>
  );
}

export const GalleryCarouselWithPreview = compose(
  withState('selectedId', 'setSelectedId', 0),
  withHandlers({
    handleClick: ({ setSelectedId }) => id => setSelectedId(id),
  }),
)(UndecoratedGalleryCarouselWithPreview);



// WEBPACK FOOTER //
// ./src/Common/Carousel/Gallery.js